/* eslint-disable */
export default {
  conferenceCall: 'Chamada de conferência',
  onHold: 'Em espera',
  ongoing: 'Em curso',
  unknown: 'Desconhecido',
  disconnected: 'Terminada',
  loading: 'A carregar…',
  loadingTimeout: 'Tempo limite de carregamento.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
